<template>
  <p class="text-reader">
    Import
    <input type="file" @change="loadTextFromFile">
  </p>
</template>

<script>
export default {
  methods: {
    loadTextFromFile(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();
      reader.onload = e => {
      this.$emit("load", e.target.result);
      }
      reader.readAsArrayBuffer(file);
    }
  }
};
</script>

<style>
.text-reader {
  position: relative;
  overflow: hidden;
  display: inline-block;
  top: -8px;
  /* Fancy button looking */
  border: none;
  pointer-events: all;
  padding: 8px 12px;
  cursor: pointer;
}
.text-reader:hover {
  cursor: pointer;
}
.text-reader input {
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 0;
  opacity: 0;
}
</style>
